<h2 mat-dialog-title>Delete Current Template?</h2>
<mat-dialog-content class="mat-dialog-content" id="currentTemplateName"> {{name}} </mat-dialog-content>
<mat-dialog-actions class="mat-dialog-actions">
    <button [mat-dialog-close]="true" mat-button id="templateYes">Yes</button>
    <button [mat-dialog-close]="false" mat-button id="templateNo">No</button>
</mat-dialog-actions>
